export {FirstMergeScreenConnected as FirstMergeScreen} from './FirstMergeScreen.connect';
